module.exports = __webpack_public_path__ + "static/media/trimflow_border_side.50ff22e3.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/img/icons/trimflow_border_side.png
// module id = 330
// module chunks = 2